import { rem } from "@huub-web/utils";

import type { Typography } from "./types/Typography";
import { responsive } from "../utils/responsive";
import { theme } from "./css/theme.css";

export const typographyDefinition: Typography = {
  bodyXS: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(12),
    lineHeight: rem(14),
  },
  bodyS: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(14),
    lineHeight: rem(18),
  },
  bodyM: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(16),
    lineHeight: rem(22),
  },
  bodyL: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(20),
    lineHeight: rem(26),
  },
  hero: {
    fontFamily: theme.fonts.secondary,
    wordBreak: "break-word",
    fontWeight: "bold",
    letterSpacing: rem(-0.5),
    lineHeight: 1,
    ...responsive({
      base: {
        fontSize: rem(48),
      },
      s: {
        fontSize: rem(68),
      },
      xl: {
        fontSize: rem(100),
      },
    }),
  },
  header: {
    fontFamily: theme.fonts.secondary,
    letterSpacing: rem(-0.5),
    wordBreak: "break-word",
    fontWeight: "bold",
    lineHeight: 1.1,
    ...responsive({
      base: {
        fontSize: rem(32),
      },
      s: {
        fontSize: rem(48),
      },
      m: {
        fontSize: rem(64),
      },
    }),
  },
  displayXS: {
    fontFamily: theme.fonts.secondary,
    fontWeight: "400",
    letterSpacing: rem(-0.5),
    lineHeight: 1.2,
    ...responsive({
      base: {
        fontSize: rem(16),
      },
      s: {
        fontSize: rem(18),
      },
      m: {
        fontSize: rem(20),
      },
    }),
  },
  displayS: {
    fontFamily: theme.fonts.secondary,
    fontWeight: "400",
    letterSpacing: rem(-0.5),
    lineHeight: 1.2,
    ...responsive({
      base: {
        fontSize: rem(18),
      },
      500: {
        fontSize: rem(24),
      },
      m: {
        fontSize: rem(24),
      },
    }),
  },
  displayM: {
    fontFamily: theme.fonts.secondary,
    fontWeight: "400",
    letterSpacing: rem(-0.5),
    lineHeight: 1.2,
    ...responsive({
      base: {
        fontSize: rem(20),
      },
      s: {
        fontSize: rem(24),
      },
      m: {
        fontSize: rem(32),
      },
    }),
  },
  displayL: {
    fontFamily: theme.fonts.secondary,
    fontWeight: "400",
    letterSpacing: rem(-0.5),
    lineHeight: 1.1,
    ...responsive({
      base: {
        fontSize: rem(24),
      },
      s: {
        fontSize: rem(32),
      },
      m: {
        fontSize: rem(42),
      },
    }),
  },
  surfaceSubtitle: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(11),
    lineHeight: rem(11),
    letterSpacing: "0.05em",
    textTransform: "uppercase",
  },
  surfaceBody: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(16),
    lineHeight: rem(22),
  },
  chatMessageL: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(24),
    lineHeight: rem(38),
  },
  chatMessageM: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(20),
    lineHeight: rem(32),
  },
  chatMessageS: {
    fontFamily: theme.fonts.primary,
    fontWeight: "400",
    fontSize: rem(16),
    lineHeight: rem(22),
  },
  monospace: {
    fontFamily: "monospace",
    fontSize: rem(12),
    lineHeight: rem(14),
    wordBreak: "break-word",
  },
};
